module.exports = __webpack_public_path__ + "static/media/icons_Bilan Scoliose.438f7915.svg";